/** Gift Card module URL prefix */
export const GIFT_CARD_BASE = '/gift-card';

export const giftCardPaths = {
  hub: GIFT_CARD_BASE,
} as const;
